export const isAuthorized = (userRoles, anyRoleRequired) => {
  return !anyRoleRequired || anyRoleRequired.some(x => userRoles && userRoles.includes(x))
}
